<script>
	import { Router, Route } from "svelte-routing";
	import Home from "./Home.svelte";
	import ChangePassword from "./ChangePassword.svelte";
	import Users from "./Users.svelte";
	import AuthRoutes from './auth/Routes.svelte';
</script>

<Router>
	<Route path="/" component={Home} />
	<Route path="/change-password" component={ChangePassword} />
	<Route path="/users" component={Users} />
	<AuthRoutes />
</Router>